import { useLocation } from "react-router-dom";
import { getQueryParams } from "../../utils/common";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../../controller/users/usersController";
import { userInfo } from "../../utils/Constants";
import { getFeaturesByUser } from "../../controller/features/featuresController";
import Wrapper from "../styles/ProfileStyled";


const Profile = (props) => {
    const { isLoading, isSuccess, currentUser } = useSelector((store) => store.users);
    const { features, isFetching } = useSelector((store) => store.features);
    const [userLoaded, setUserLoaded] = useState(false); // ✅ Track if we fetched user

    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = getQueryParams(location.search);
    const [userInfoObj, setUserInfoObj] = useState(userInfo);

    useEffect(() => {
        if (!queryParams.userId && !userLoaded) {
            if (!currentUser?.name) {
                dispatch(getCurrentUser());
            }
            setUserLoaded(true); // ✅ Prevents infinite loop
        }
    }, [queryParams, userLoaded, currentUser, dispatch]);

    // ✅ Fix: Only update userInfoObj when values actually change
    useEffect(() => {
        const newUserData = queryParams.userId
            ? {
                userId: queryParams.userId,
                createdAt: queryParams.createdAt,
                name: queryParams.name,
                email: queryParams.email,
                role: queryParams.role,
                active: queryParams.active
            }
            : {
                userId: currentUser?._id || "",
                createdAt: currentUser?.createdAt || "",
                name: currentUser?.name || "",
                email: currentUser?.email || "",
                role: currentUser?.role || "",
                active: currentUser?.active || ""
            };

        // ✅ Prevent unnecessary re-renders
        setUserInfoObj((prevUserInfo) =>
            JSON.stringify(prevUserInfo) !== JSON.stringify(newUserData)
                ? newUserData
                : prevUserInfo
        );
    }, [queryParams, currentUser]);

    // ✅ Fetch Features when user ID is available
    useEffect(() => {
        if (userInfoObj.userId) {
            dispatch(getFeaturesByUser(userInfoObj.userId));
        }
    }, [userInfoObj.userId, dispatch]);

    if (isLoading || isFetching) return <h2>Loading...</h2>;

    return (
        <Wrapper>
            <div className="profile-container">
                <div className="profile-card">
                    <h2>{userInfoObj.name}</h2>
                    <p>Email: {userInfoObj.email}</p>
                    <p>Role: {userInfoObj.role}</p>
                    <p>Status: {userInfoObj.active ? "Active" : "Not Active"}</p>
                    <p>Joined: {new Date(userInfoObj.createdAt).toLocaleDateString()}</p>
                </div>

                <div className="features-container">
                    <h3>Available Features</h3>
                    {features?.data && Object.keys(features.data).length > 0 ? (
                        <ul>
                            {Object.entries(features.data).map(([key, value]) => (
                                <li key={key}>
                                    {key.replace(/([A-Z])/g, " $1").trim()}:{" "}
                                    {value ? "Enabled ✅" : "Disabled ❌"}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No features assigned.</p>
                    )}
                </div>
            </div>
        </Wrapper>
    );
};
export default Profile;